import styled, {css} from "styled-components"

const StyledImage = styled.img`
  ${({theme}) => css`
    background: ${theme.colors.greys.white};
    border-radius: 50%;
    height: 100px;
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    width: 100px;

    left: ${theme.spacing.three};
    ${theme.mediaQueries.minWidthMedia.tablet`
      left: ${theme.spacing.five};
    `}
  `}
`

export default StyledImage
